import { StateChanges } from './stateChanges'

const basicMutations = {

  [StateChanges.SET_FOOTNOTE_RESULTS]: function (state, responseData) {
    state.footnoteApiResponse = responseData
  },
  [StateChanges.SET_TEXT_FOR_API_CALL]: function (state, newText) {
    state.textForApiCall = newText;
  },
  [StateChanges.SET_DIRECT_RESULTS]: function (state, val) {
    state.directMatch = val
  },
  [StateChanges.SET_VISUALIZER]: function (state, val) {
    state.visualizerView = val;
  },
  [StateChanges.SET_MIN_RANGE]: function (state, val) {
    state.minRange = val;
  },
  [StateChanges.SET_MAX_RANGE]: function (state, val) {
    state.maxRange = val;
  },
  [StateChanges.SET_DATA]: function (state, newData) {
    state.data = newData;
  },
  [StateChanges.SET_ALL_RESULTS]: function (state, newData) {
    state.allResults = newData;
  },
  [StateChanges.SET_SELECTED_RESULTS]: function (state, newData) {
    state.selectedResults = newData
  },
  [StateChanges.SET_TALMUD_RESULTS]: function (state, newData) {
    state.talmudResults = newData;
  },
  [StateChanges.SET_MISHNA_RESULTS]: function (state, newData) {
    state.mishnaResults = newData;
  },
  [StateChanges.SET_TANAKH_RESULTS]: function (state, newData) {
    state.tanakhResults = newData;
  },
  [StateChanges.SET_MODE]: function (state, val) {
    state.mode = val;
  },
  [StateChanges.SET_VERSE_FOR_CHAPTER]: function (state, newData) {
    state.verseForChapter = newData
  },
  [StateChanges.SET_CHAPTER_RESULTS]: function (state, newData) {
    state.chapterResults = newData
  },
  [StateChanges.SET_VISUALIZER_MODE]: function (state, newData) {
    state.visualizerModes = newData
  },
  [StateChanges.SET_VISUALIZER_RESULTS]: function (state, val) {
    state.visualizerResults = val
  },
  [StateChanges.SET_NO_RESULTS]: function (state, val) {
    state.noResults = val;
  },
  [StateChanges.SET_HIGHER_THRESHOLD_RESULTS]: function (state, val) {
    state.higherResults = val;
  },
  [StateChanges.SET_LOWER_THRESHOLD_RESULTS]: function (state, val) {
    state.lowerResults = val;
  },
  [StateChanges.SET_EXTERNAL_TALMUD_RESULTS]: function (state, val) {
    state.extTalmudRes = val;
  },
  [StateChanges.SET_EXTERNAL_TANAKH_RESULTS]: function (state, val) {
    state.extTanakhRes = val;
  },
  [StateChanges.FOOTNOTES_COMPLETE]: function (state, val) {
    state.footnotesComplete = val;
  },
  [StateChanges.SET_SERVER_ERROR]: function (state, val) {
    state.serverError = val;
  }
}

export default basicMutations
